const ApproveRejectModal = ({
  isOpen = false,
  onClose = () => {},
  approveBtnFnc = () => {},
  rejectBtnFnc = () => {},
  type = "approve",
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-lg w-full md:p-10 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className="text-center text-lg md:text-xl font-semibold text-gray-800">
              Are you sure you want to {type}?
            </h1>
            <div className="flex justify-between gap-5 mt-10">
              <button
                onClick={onClose}
                className="border border-primary text-primary text-base font-medium py-2 w-1/2 max-w-[14rem] rounded-md"
              >
                Cancel
              </button>
              {type === "approve" && (
                <button
                  onClick={() => {
                    onClose();
                    approveBtnFnc();
                  }}
                  className="bg-secondary text-white text-base font-medium py-2 w-1/2 max-w-[12rem] rounded-md"
                >
                  Approve
                </button>
              )}
              {type === "reject" && (
                <button
                  onClick={() => {
                    onClose();
                    rejectBtnFnc();
                  }}
                  className="bg-errorColor text-white text-base font-medium py-2 w-1/2 max-w-[12rem] rounded-md"
                >
                  Reject
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ApproveRejectModal;
